import { useEffect, useState } from "react";
import { Button, Form, Input, List, Modal, Space, Table, Popconfirm, Tooltip, Switch, Tag } from "antd";
import {
    DownloadOutlined, FilePdfOutlined, LeftOutlined,
    QuestionCircleOutlined, RightOutlined,
    SearchOutlined, CheckCircleOutlined, CloseCircleOutlined,
    ExclamationCircleOutlined, FilterOutlined,
    UsergroupAddOutlined
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import Search from "antd/es/input/Search";
import { xcService } from "../../../../_services/xcService";
import localOrSessionStore from "../../../../_helpers/localOrSessionStore";
import variables from "../../../../_constants/variables";
import moment from "moment";
import config from "_config/config.js";
import { Select } from 'antd';
import { Excel } from "antd-table-saveas-excel";
import { Collapse, notification } from 'antd';
import { useSelector } from "react-redux";
import { pdf } from "@react-pdf/renderer";
import { MyDocPDFCenterTemplate } from "views/centers/components/pdfcontracttemplate";

const { Panel } = Collapse;

const CentersView = () => {
    const { t } = useTranslation();
    const storage = localOrSessionStore({ key: variables.REMEMBER });
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [sourceData, setSourceData] = useState([]);
    const [towns, setTowns] = useState([]);
    const [provinces, setProvinces] = useState([]);
    const [ccaa, setCCAA] = useState([]);

    const [showInviteUserModal, setShowInviteUserModal] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [currentCenter, setCurrentCenter] = useState(false);
    const userType = storage.getItem(variables.USER_TYPE);
    const [userProfile, setUserProfile] = useState();
    const [actualPage, setActualPage] = useState(1)

    const [cXelence, setcXelence] = useState(false);
    const [cValidados, setcValidados] = useState(false);
    const [cValidar, setcValidar] = useState(false);
    const [cIncompleto, setcIncompleto] = useState(false);
    const [firstTime, setFirstTime] = useState(true);
    const [allCodes, setAllCodes] = useState([]);


    const [cTowns, setcTowns] = useState([]);
    const [cProvince, setcProvince] = useState([]);
    const [cCCAA, setcCCAA] = useState([]);
    const [codes, setCodes] = useState([]);
    const [aYears, setAYears] = useState([]);
    const [isFiltered, setFiltered]= useState(false);

    const coursesData = useSelector((state) => state.dataReducer.coursesData);

    const localDownloadPDF = async (pdfName, propsPdf) => {
        const blob = await pdf(<MyDocPDFCenterTemplate props= {propsPdf} />).toBlob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = pdfName || 'document.pdf';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      };

    const onChangeCode = (value) => {

        setFiltered(false)
        setCodes(value);
    };
    const applyFilters = () => {
        getListado()
    }
    useEffect(() => {
        let mIni = 22;
        let mTemp = []
        while (mIni <  (moment().format('YY') )){
            mTemp.push( {
                text: "20" + mIni + "/20" + (mIni + 1),
                value: mIni
            });
            mIni++;
        }
        setAYears(mTemp)

        xcService.getToken(`/v1/master/centercodes`).then(({data}) => {

            setAllCodes(data.data.map(item => item.code).filter(onlyUnique).map(c => {
                return {
                    label: c,
                    value: c
                }
            }))
        });

    },[])
    const getListado = () => {
        let mPayload = {
            xcelence: cXelence,
            validados: cValidados,
            validar: cValidar,
            incompleto: cIncompleto,
            towns: cTowns,
            province: cProvince,
            ccaa: cCCAA, codes: codes
        }
        if (cXelence ||cValidados || cValidar ||cIncompleto ||cTowns.length > 0 || cProvince.length > 0 ||cCCAA.length > 0 ||codes.length > 0){
            setFiltered(true);
        }
        xcService.postToken(`/v1/master/centers`,mPayload)
            .then(({ data }) =>


                data.data.map(center => {
                    return {
                        ...center,
                        orientadores: center.tutors.map(item => item.name + " " + item.surname + " ("+item.email+")\n"),
                        jefeest: center.jefeEstudios ? center.jefeEstudios.split("#")[0] + " " + center.jefeEstudios.split("#")[1] : "",
                        yearscenter: center.centerhistories.sort((a,b) => a.year - b.year).map(it => "20" + it.year + "/20" + (+it.year + 1)).filter(onlyUnique),
                        yearscenterxl: center.centerhistories.sort((a,b) => a.year - b.year).map(it => "20" + it.year + "/20" + (+it.year + 1)).filter(onlyUnique),

                        jefeestmail: center.jefeEstudios ? center.jefeEstudios.split("#")[2]  : "",
                        name: center.name.replaceAll("&quot;", ""),
                        centroxcelence: center.xcelence ? "Sí" : "No",
                        director: (center.directorName ?? '') + ' ' + (center.directorSurname ?? ''),
                        type: center.type === 1 ? t("registercenter.tipo1") : center.type === 2 ? t("registercenter.tipo2") : t("registercenter.tipo3"),
                        state: center.rejected ? t("tutores.informes.rejected") :
                            center.validated ? t("tutores.informes.validado") :
                                !center.pdf ? t("tutores.informes.registrado") : t("tutores.informes.pendiente")
                    }
                }))
            .then(centers => {
                setShowFilters(false);
                if (firstTime){
                        setTowns(centers.map(data => data.town)
                            .filter(onlyUnique)
                            .sort((a, b) => a?.localeCompare(b))
                            .map(town => {
                                return {
                                    text: town,
                                    value: town
                                }
                            }))

                        setProvinces(centers.map(data => data.province)
                            .filter(onlyUnique)
                            .sort((a, b) => a?.localeCompare(b))
                            .map(province => {
                                return {
                                    text: province,
                                    value: province
                                }
                            }))

                        setCCAA(centers.map(data => data.ccaa)
                            .filter(onlyUnique)
                            .sort((a, b) => a?.localeCompare(b))
                            .map(ccaa => {
                                return {
                                    text: ccaa,
                                    value: ccaa
                                }
                            }))
                }
                setFirstTime(false)
                setTableData(centers)
                setSourceData(centers)
            })
    }

    function onlyUnique(value, index, self) {
        return self?.indexOf(value) === index;
    }

    const onSearch = ({ target }) => {

        let mSearch = target.value.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "")

        setTableData(target.value.toLowerCase() === '' ? sourceData : sourceData.filter((item) => {

            return item.name.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "").includes(mSearch)
                ||item.code.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "").includes(mSearch)
                ||item.director.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "").includes(mSearch)
                ||item.email.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "").includes(mSearch)

        }))
    }
    const columns = [
        {
            title: t("tutores.informes.tableselect"),
            dataIndex: 'name',
            render: (text) => <p className={"text-data"}>{text}</p>,
            sorter: (a, b) => a.name?.localeCompare(b.name)
        },
        {
            title: t("tutores.informes.tableemail"),
            dataIndex: 'email',
            render: (text) => <p className={"text-data text-data--small"}>{text}</p>,
            sorter: (a, b) => a.email?.localeCompare(b.email)
        },
        {
            title: t("tutores.informes.tabletelephone"),
            dataIndex: 'phone',
            render: (text) => <p className={"text-data text-data--small"}>{text}</p>,
            sorter: (a, b) => a.phone - b.phone
        },
        {
            title: "Director",
            dataIndex: 'director',
            render: (text) => <p className={"text-data text-data--small"}>{text}</p>,
            sorter: (a, b) => a.director?.localeCompare(b.director)

        },
        {
            title: t("tutores.informes.tablecode"),
            dataIndex: 'code',
            render: (text) => <p className={"text-data text-data--small"}>{text}</p>,
            sorter: (a, b) => a.code - b.code
        },

        {
            title: t("lClave"),
            dataIndex: 'passcode',
            render: (text) => <p className={"text-data text-data--small"}>{text}</p>,
        },
        {
            title: t("informes.tableYearColHeading"),
            dataIndex: 'centerhistories',
            render: (text, record) => {


                return record && record.yearscenter && record.yearscenter.filter(onlyUnique).map(c => {
                    return <div><Tag color="blue">{c}</Tag></div>

                })
            },
            filters: Array.prototype.concat.apply([], tableData.map(data => data.yearscenter))
                .filter(onlyUnique)
                .sort((a, b) => a?.localeCompare(b))
                .map(type => {
                    return {
                        text: type,
                        value: type
                    }
                }),
            onFilter: (value, record) => {
                return record.yearscenter?.indexOf(value) !== -1
            }

        },

        {
            title: t("registercenter.tipocentro"),
            dataIndex: 'type',
            render: (text) => <p className={"text-data text-data--small"}>{text}</p>,
            sorter: (a, b) => a.type?.localeCompare(b.type),
            filters: tableData.map(data => data.type)
                .filter(onlyUnique)
                .sort((a, b) => a?.localeCompare(b))
                .map(type => {
                    return {
                        text: type,
                        value: type
                    }
                }),
            onFilter: (value, record) => {
                return record.type?.indexOf(value) === 0
            }
        },
        {
            title: t("centroxcelence"),
            dataIndex: 'centroxcelence',
            render: (text) => <p className={"text-data text-data--small"}>{text}</p>,
            filters: tableData.map(data => data.centroxcelence)
                .filter(onlyUnique)
                .sort((a, b) => a?.localeCompare(b))
                .map(type => {
                    return {
                        text: type,
                        value: type
                    }
                }),
            onFilter: (value, record) => {
                return record.centroxcelence?.indexOf(value) === 0
            }
        },
        {
            title: t("tutores.informes.tablestate"),
            dataIndex: 'state',
            render: (text, record) => {
                if (record.rejected) {
                    return <div style={{ fontSize: '11px', color: '#CF1322' }}><CloseCircleOutlined
                        style={{ fontSize: '11px', fill: '#CF1322' }} />{t("tutores.informes.rejected")}</div>
                } else {
                    if (record.validated) {
                        return <div style={{ fontSize: '11px', color: '#389E0D' }}><CheckCircleOutlined
                            style={{ fontSize: '11px', fill: '#389E0D' }} />{t("tutores.informes.validado")}</div>
                    } else {
                        if (!record.pdf){
                            return <div style={{ fontSize: '11px', color: '#FFB81C' }}><ExclamationCircleOutlined
                                style={{ fontSize: '11px', fill: '#FFB81C' }} />{t("tutores.informes.registrado")}</div>
                        }else{
                            return <div style={{ fontSize: '11px', color: '#FFB81C' }}><ExclamationCircleOutlined
                                style={{ fontSize: '11px', fill: '#FFB81C' }} />{t("tutores.informes.pendiente")}</div>
                        }

                    }
                }
            },

            filters: [
                {
                    text: t("tutores.informes.validado"),
                    value: t("tutores.informes.validado"),
                },
                {
                    text: t("tutores.informes.pendiente"),
                    value: t("tutores.informes.pendiente"),
                },
                {
                    text: t("tutores.informes.registrado"),
                    value: t("tutores.informes.registrado"),
                },
                {
                    text: t("tutores.informes.rejected"),
                    value: t("tutores.informes.rejected"),
                },
            ],
            onFilter: (value, record) => {

                if (value === t("tutores.informes.pendiente")) {
                    // pendientes
                    return !record.validated && !record.rejected && record.pdf
                } else {
                    if (value === t("tutores.informes.registrado")) {
                        // pendientes
                        return !record.validated && !record.rejected && !record.pdf
                    } else {
                        if (value === t("tutores.informes.rejected")) {
                            return record.rejected
                        } else {
                            return record.validated
                        }
                    }
                }

            },
        },
        {
            title: t("tutores.informes.tableviewcenter"),
            key: 'view',
            render: (_, record) => (
                <Space size="middle">
                    <div className={"text-show-data"}><a
                        onClick={() => setCurrentCenter(tableData.find(tutor => tutor.email === record.email))}>{t("tutores.informes.view")}
                        <RightOutlined /></a></div>
                </Space>
            ),
        },
    ];

    useEffect(() => {

        if (userType !== 'MASTER')
            xcService.getToken(userType === 'CENTER' ? '/v1/center/me' : '/v1/tutor/me').then(({ data }) => {
                setUserProfile(data.data)
            });


        getListado()
    }, [])

    const sendCenter = (center) => {
        xcService.getToken(`/v1/master/center/reset/${center.code}`).then(data => {
            setCurrentCenter({ ...currentCenter, complete: true })
            getListado()

        })
    }

    const validateCenter = (id) => {
        xcService.putToken(`/v1/master/center/validate/${id}`).then(data => {
            setCurrentCenter({ ...currentCenter, validated: true })
            getListado()

        })
    }


    const desvinculaCenter = (id) => {
        xcService.putToken(`/v1/master/center/reject/${id}`).then(data => {
            setCurrentCenter({ ...currentCenter, validated: false })
            getListado()
            setCurrentCenter(null)

        })
    }

    const eliminarCenter = (id) => {
        xcService.putToken(`/v1/master/center/delete/${id}`).then(data => {
            getListado()
            setCurrentCenter(null)
        })
    }


    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const showNotification = () => {
        notification.success({
            message: 'Contrato en descarga',
            description: 'El contrato ha sido generado con los datos más recientes.',
            duration: 4,
            style: { backgroundColor: '#fdecea', border: '1px solid #f5c6cb', color: '#721c24' },
        });
      };

    const downloadPdf = async (pdf, code, year) => {
        let fullUrl = `${config.backendUrl}/v2/${userType === "MASTER" ? "m" : "c"}contract/${pdf}?code=${code}`;

        const result = await fetch(fullUrl, {
            headers: {
                Authorization: "bearer " + storage.getItem(variables.TOKEN),
                "Content-Type": "application/json",
            }
        });

        if (result?.status === 404) {
            const _result = await result.json()

            const data = _result.data;
            const { values: vstr, values2: v2str} = data || {}

            const values = JSON.parse(vstr)
            const values2 = JSON.parse(v2str)

            const propsPdf = {
              year: year,
              ccaa: currentCenter.ccaa,
              user: {email: currentCenter.email},
              center: {
                Nombre: currentCenter.name,
                Codigo: values.code || currentCenter.code,
                Domicilio: currentCenter.address,
                CodPostal: currentCenter.postalcode,
                Telefono: currentCenter.phone,
              },
              courses: coursesData || [],
              values: {
                ...values,
                orientadores: values2.orientadores || currentCenter.orientadores || [],
                directorName: values2.directorName || currentCenter.directorName,
                directorDocumentType: values2.directorDocumentType || currentCenter.directorDocumentType,
                directorDni: values2.directorDni || currentCenter.directorNif,
                directorNie: values2.directorNie || currentCenter.directorNie,
                directorSurname: values2.directorSurname || currentCenter.directorSurname,
                jefeEmail: values2.jefeEmail || currentCenter.jefeestmail,
                directorEmail: values2.directorEmail || currentCenter.directorEmail,
                jefeName: values2.jefeName || currentCenter.jefeest,
                jefeSurname: values2.jefeSurname || "",
                orientadornombre: values2.orientadornombre || "",
                orientadorapellidos: values2.orientadorapellidos || "",
                orientadortelef: values2.orientadortelef || "",
                orientadoremail: values2.orientadoremail || "",
                orientadordni: values2.orientadordni || "",
              },
            };

            await localDownloadPDF( pdf, propsPdf);
            await uploadPDF(pdf, propsPdf);

            showNotification(); /* TODO: por comentar posiblemente no se usara*/
            return;
        }

        const blob = await result.blob();
        const href = window.URL.createObjectURL(blob);
        window.open(href, '_blank');
    }

    const uploadPDF = async (pdfId, propsPdf) => {
        const _pdfId = pdfId.replace('.pdf', '')
        const blob = await pdf(<MyDocPDFCenterTemplate props= {propsPdf} />).toBlob();
        const formData = new FormData();
        formData.append("file", new File([blob], pdfId || "document.pdf", { type: "application/pdf" }));
      
        try {
          const response = await fetch(`${config.backendUrl}/v1/uploadcontract/${_pdfId}`, {
            method: "POST",
            body: formData,
          })
          ;
          if (!response.ok) throw new Error("Error al subir el archivo");
        //   const fileName = await response.text();
        } catch (error) {
          console.error("Error al subir el PDF:", error);
        }
      };


    const onChangePage = (pageNumber) => {
        setActualPage(pageNumber.current);
        localStorage.setItem("CENTERPAGE", pageNumber.current);
    };

    const goBack = () => {
        let mPage = 1;
        if (localStorage.getItem("CENTERPAGE")) {
            mPage = +localStorage.getItem("CENTERPAGE")
        }
        setActualPage(mPage);
        setCurrentCenter(null)

    }



    const headersCsv = [
        { title: t("tutores.informes.tableename"), key: "name", dataIndex: "name" },
        { title: t("tutores.informes.tablecode"), key: "code", dataIndex: "code" },
        { title: t("tutores.informes.tableemail"), key: "email", dataIndex: "email" },
        { title: t("tutores.informes.tabletelephone"), key: "phone", dataIndex: "phone" },
        { title: t("centerr.codigop"), key: "postalcode", dataIndex: "postalcode" },
        { title: t("registro.provincia"), key: "province", dataIndex: "province" },
        { title: t("registercenter.director.title"), key: "director", dataIndex: "director" },
        { title: t("centroxcelence"), key: "centroxcelence", dataIndex: "centroxcelence" },
        { title: t("informes.tableYearColHeading"), key: "type", dataIndex: "yearscenterxl" },
        { title: t("registercenter.tipocentro"), key: "type", dataIndex: "type" },
        { title: t("registercenter.director.title") + " " + t("tutores.informes.tableemail"), key: "directorEmail", dataIndex: "directorEmail" },
        { title: t("registercenter.director.title") + " " + t("registro.nif"), key: "directorNif", dataIndex: "directorNif" },
        { title: t("centerr.jefe"), key: "jefeest", dataIndex: "jefeest" },
        { title: t("registercenter.jefe.email"), key: "jefeestmail", dataIndex: "jefeestmail" },
        { title: t("menu.orienta"), key: "orientadores", dataIndex: "orientadores" },
        { title: t("tutores.informes.tablestate"), key: "state", dataIndex: "state" }


    ];

    const exportXLS = () => {
        const excel = new Excel();
        excel
            .addSheet("centers")
            .addColumns(headersCsv)
            .addDataSource(tableData, {
                str2Percent: true
            })
            .saveAs("centersExport" + moment().format(("YYYYMMDD")) + ".xlsx");
    }


    const onChangeAcc = (key) => {
        console.info(key);
    };


    useEffect(() => {
        if (!isFiltered)
            getListado();
    }, [isFiltered])
    const clearFilters = () => {

        setcTowns([]);
        setcProvince([]);
        setcCCAA([]);
        setCodes([]);
        setcIncompleto(false);
        setcValidar(false);
        setcValidados(false);
        setcXelence(false);
        setFiltered(false);
    }
   
    const onChangeTowns = (value) => {
        setcTowns(value);
    };
    const onChangeProvince = (value) => {
        setcProvince(value);
    };
    const onChangeCCAA = (value) => {
        setcCCAA(value);
    };
    const onChangeIncompleto = (checked) => {
        setcIncompleto(checked)
    };
    const onChangeValidar = (checked) => {
        setcValidar(checked);
    };
    const onChangeValidados = (checked) => {
        setcValidados(checked)
    };
    const onChangeXcelence = (checked) => {
        setcXelence(checked)
    };


    return (
        <>
            {showFilters &&
                <Modal className={"modalName modal-question modal-question--xs modal-custom--xs"}
                    title={t("filtros")}
                    centered
                    visible={showFilters}
                    okText={t("showres")}
                    onOk={() => applyFilters()}
                    onCancel={() => setShowFilters(false)}
                >

                    <Collapse defaultActiveKey={['0']} onChange={onChangeAcc}>
                        <Panel header={t("filtro.Registroincompleto")} key="Registroincompleto">
                            <Switch checked={cIncompleto} onChange={onChangeIncompleto} /> {t("filtro.Registroincompleto")}
                        </Panel>
                        <Panel header={t("filtro.PendientesValidar")} key="PendientesValidar">
                            <Switch  checked={cValidar} onChange={onChangeValidar} /> {t("filtro.PendientesValidar")}
                        </Panel>
                        <Panel header={t("filtro.Validados")} key="Validados">
                            <Switch  checked={cValidados} onChange={onChangeValidados} /> {t("filtro.Validados")}
                        </Panel>
                        <Panel header={t("login.city")} key="1">
                            <Select
                                value={cTowns}
                                style={{ width: "90%" }}
                                mode="multiple"
                                allowClear
                                placeholder={t("login.city")}
                                optionFilterProp="children"
                                onChange={onChangeTowns}

                                filterOption={(input, option) => {


                                    return (option?.value ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                }
                                options={towns}
                            />
                        </Panel>
                        <Panel header={t("login.province")} key="2">
                            <Select   value={cProvince}
                                style={{ width: "90%" }}
                                mode="multiple"
                                allowClear
                                placeholder={t("login.province")}
                                optionFilterProp="children"
                                onChange={onChangeProvince}

                                filterOption={(input, option) =>
                                    (option?.value ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                options={provinces}
                            />
                        </Panel>
                        <Panel header={t("login.autcommunity")} key="3">

                            <Select value={cCCAA}
                                style={{ width: "90%" }}
                                mode="multiple"
                                allowClear
                                placeholder={t("login.autcommunity")}
                                optionFilterProp="children"
                                onChange={onChangeCCAA}

                                filterOption={(input, option) =>
                                    (option?.value ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                options={ccaa}
                            />


                        </Panel>

                        <Panel header={t("filtro.codigo")} key="codigo">
                            {allCodes && allCodes.length > 0 &&
                                <Select
                                    value={codes}
                                    style={{width: "50%"}}
                                    mode="multiple"
                                    allowClear
                                    isMulti
                                    placeholder={t("filtro.codigo")}
                                    optionFilterProp="children"
                                    onChange={onChangeCode}

                                    options={allCodes}

                                />
                            }
                        </Panel>
                        <Panel header={t("filtro.CentrosXcelence")} key="CentrosXcelence">
                            <Switch checked={cXelence} onChange={onChangeXcelence} /> {t("filtro.CentrosXcelence")}
                        </Panel>
                    </Collapse>


                </Modal>
            }

            {showInviteUserModal &&
                <Modal className={"modalName modal-question modal-question--tutor"}
                    title={t("tutores.informes.titlemodal")}
                    centered
                    visible={showInviteUserModal}
                    onCancel={() => setShowInviteUserModal(false)}
                >
                    <Form className="authForm allHeightMobile"
                        name="basic"
                        layout="vertical"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        initialValues={{ remember: true }}
                        autoComplete="off"
                    >
                        <p>{t("tutores.informes.subtitlemodal")}</p>
                        <Form.Item
                            label={<div>
                                <span className={"text-label"}>{t("registro.codigoc")}</span>&nbsp;&nbsp;
                                <Tooltip title={t("registro.tooltipcodigo")}>
                                    <QuestionCircleOutlined />
                                </Tooltip>
                            </div>}
                            name="centerCode"
                            rules={[
                                {
                                    required: false,
                                    message: t("mandatory"),
                                },
                            ]}
                        >
                            <Input placeholder={t("registro.codigoc")} />
                            <Button className="btnWhiteBlue modal-question--button"
                                htmlType="button">{t("tutores.informes.copy")}</Button>
                        </Form.Item>

                        <Form.Item
                            // label={t("registro.clave")}
                            label={<div>
                                <span className={"text-label"}>{t("registro.clave")}</span>&nbsp;&nbsp;
                                <Tooltip title={t("registro.tooltipclave")}>
                                    <QuestionCircleOutlined />
                                </Tooltip>
                            </div>}
                            name="passwordCenter"
                            rules={[
                                {
                                    required: false,
                                    message: t("mandatory"),
                                },
                            ]}
                        >
                            <Input.Password
                                placeholder={t("registro.clavep")}
                            />
                            <Button className="btnWhiteBlue  modal-question--button"
                                htmlType="button">{t("tutores.informes.copy")}</Button>

                        </Form.Item>
                        {/*{errorCenter &&
                            <Row><Col span={24}>
                                <Alert message={t("registro.errorCenter")} type="error" />
                            </Col></Row>
                        }*/}
                        <Form.Item
                            label={<div>
                                <span className={"text-label"}>{t("tutores.informes.titleemail")}</span>&nbsp;&nbsp;
                            </div>}
                            name="email"
                            rules={[
                                {
                                    required: false,
                                    message: t("mandatory"),
                                },
                            ]}
                        >
                            <p>{t("tutores.informes.textinvite")}</p>
                            <Input placeholder={t("tutores.informes.placeinvite")} />
                            <Button className="btnWhiteBlue  modal-question--button"
                                htmlType="button">{t("tutores.informes.sendinvitation")}</Button>
                        </Form.Item>
                        <Form.Item
                            label={<div>
                                <span className={"text-label"}>{t("tutores.informes.titlelink")}</span>&nbsp;&nbsp;
                            </div>}
                            name="enlace"
                            rules={[
                                {
                                    required: false,
                                    message: t("mandatory"),
                                },
                            ]}
                        >
                            <p>{t("tutores.informes.textlink")}</p>
                            <Input placeholder={t("tutores.informes.placelink")} />
                            <Button className="btnWhiteBlue  modal-question--button"
                                htmlType="button">{t("tutores.informes.copylink")}</Button>
                        </Form.Item>

                        <Form.Item className="buttons-pre-next">
                            <Button onClick={() => setShowInviteUserModal(false)}
                                className="modal-question--button modal-question--button--cancel"
                                htmlType="button">{t("tutores.informes.cancel")}</Button>
                        </Form.Item>
                    </Form>
                </Modal>
            }
            {!currentCenter && <div>
                <div className={"informes-header"}>
                    <div className={"informes-header__top"}>
                        <h1 className={"is-first"}>{t("menu.centros")}</h1>
                        <Button className={"btnWhiteBlue"}
                            onClick={() => setShowInviteUserModal(true)}><UsergroupAddOutlined />{t("alumnos.familyButton")}
                        </Button>
                    </div>
                    <p>{t("tutores.informes.subtitlecenter")}</p>
                    <div className={"informes-header__bottom"}>
                        <div className={"informes-header__bottom-left"}>
                            <Search
                                placeholder={t("tutores.informes.search")}
                                allowClear
                                enterButton={<SearchOutlined />}
                                size="large"
                                onChange={onSearch}
                            />

                        </div>
                        <div className={"informes-header__bottom-right"}>
                            {userType === 'MASTER' &&
                                <>
                                {isFiltered &&
                                    <Button onClick={() => clearFilters()} className={"btnWhiteBlue"}><CloseCircleOutlined />{t("borrarfiltros")}
                                    </Button>

                                }

                                    <Button onClick={() => setShowFilters(true)} className={"btnWhiteBlue"}><FilterOutlined />{t("filtros")}
                                    </Button>
                                </>
                            }

                            <Button onClick={exportXLS} className={"btnWhiteBlue"}><DownloadOutlined />{t("tutores.informes.downloadButton")}
                            </Button>

                        </div>
                    </div>
                </div>
                <div className={"report-table"}>

                    <Table rowKey={"id"}
                        onChange={onChangePage}
                        pagination={{ current: actualPage, position: ['bottomCenter'] }} rowSelection={rowSelection}
                        columns={columns}
                        dataSource={tableData} />
                </div>
            </div>}
            {currentCenter &&
                <div>
                    <div className={"informes-header"}>
                        <a className={"informes-header__back"}
                            onClick={() => goBack()}><LeftOutlined /> {t("backtolist")}</a>
                        <div className={"informes-header__top"}>
                            <h1>{currentCenter.name}</h1>
                        </div>
                        <div className={"cardStudent cardStudent--max-width"}>
                            <div className={"itemCard itemCardHeader"}>{t("informes.card.title")}</div>
                            <div className={"itemCard"}>
                                <div className={"itemCardLeft"}>{t("tutores.informes.tabledirector")}:</div>
                                <div className={"itemCardRight"}>{currentCenter.director}</div>
                            </div>
                            <div className={"itemCard"}>
                                <div className={"itemCardLeft"}>{"Email Director"}:</div>
                                <div className={"itemCardRight"}>{currentCenter.directorEmail}</div>
                            </div>
                            <div className={"itemCard"}>
                                <div className={"itemCardLeft"}>{ currentCenter.directorDocumentType == 'DNI' ?  t("tutores.informes.tablenif") :  t("tutores.informes.tablenie")}:</div>
                                <div className={"itemCardRight"}>{ currentCenter.directorDocumentType == 'DNI' ? currentCenter.directorNif : currentCenter.directorNie}</div>
                            </div>
                            <div className={"itemCard"}>
                                <div className={"itemCardLeft"}>{t("account.telefono")}:</div>
                                <div className={"itemCardRight"}>{currentCenter.phone}</div>
                            </div>
                            <div className={"itemCard"}>
                                <div className={"itemCardLeft"}>{t("account.direccion")}:</div>
                                <div className={"itemCardRight"}>{currentCenter.address}</div>
                            </div>
                            <div className={"itemCard"}>
                                <div className={"itemCardLeft"}>{t("tutores.informes.tablecode")}:</div>
                                <div className={"itemCardRight"}>{currentCenter.code}</div>
                            </div>
                            <div className={"itemCard"}>
                                <div className={"itemCardLeft"}>{t("account.claveorion")}:</div>
                                <div className={"itemCardRight"}>{currentCenter.passcode}</div>
                            </div>
                            <div className={"itemCard"}>
                                <div className={"itemCardLeft"}>{t("registercenter.tipocentro")}:</div>
                                <div className={"itemCardRight"}>
                                    {currentCenter.type &&
                                        currentCenter.type
                                    }

                                </div>
                            </div>
                        </div>


                        <div style={{ display: "flex", flexDirection: "row" }}>
                            {currentCenter.complete && !currentCenter.validated && !currentCenter.rejected &&
                                <Popconfirm onConfirm={() => desvinculaCenter(currentCenter.id)}
                                    title={t("segurodesvincularcentro")}
                                    okText={t("yes")}
                                    cancelText="No"
                                ><Button className={"btnWhiteBlue"}>
                                        {t("tutores.tutor.reject")}
                                    </Button></Popconfirm>
                            }


                            <>
                                <Popconfirm onConfirm={() => eliminarCenter(currentCenter.id)}
                                    title={t("seguroeliminarcentro")}
                                    okText={t("yes")}
                                    cancelText="No"
                                ><Button className={"btnWhiteBlue"}>
                                        {t("tutores.informes.tabledelete")}
                                    </Button></Popconfirm>

                            </>

                            {
                                !currentCenter.complete && !currentCenter.rejected && !currentCenter.validated ?
                                    <>
                                        &nbsp;&nbsp;<Popconfirm onConfirm={() => sendCenter(currentCenter)}
                                            title={t("segurcompletar")}
                                            okText={t("yes")}
                                            cancelText="No"
                                        ><Button className={"btnWhiteBlue"}>
                                                {t("tutores.tutor.completar")}
                                            </Button></Popconfirm>
                                    </>
                                    :
                                    currentCenter.complete && !currentCenter.validated && !currentCenter.rejected &&

                                    <>
                                        &nbsp;&nbsp;<Popconfirm onConfirm={() => validateCenter(currentCenter.id)}
                                            title={t("segurovalidarcentro")}
                                            okText={t("yes")}
                                            cancelText="No"
                                        ><Button className={"btnWhiteBlue"}>
                                                {t("tutores.tutor.validate")}
                                            </Button></Popconfirm>
                                    </>

                            }
                        </div>
                        <div>

                            <div className={"informes-header"}>
                                <div className={"informes-header__top"}>
                                    <h1>Contratos</h1>
                                </div>
                                <div className={"cardStudent cardStudent--max-width"}>
                                    <List
                                        itemLayout="horizontal"
                                        dataSource={currentCenter.centerhistories}
                                        renderItem={(item) => (
                                            <List.Item
                                                className="px-2"
                                                actions={[<a onClick={() => downloadPdf(item.pdf, currentCenter.code, item.year)} target={"_blank"}>
                                                    <DownloadOutlined />
                                                </a>]}
                                            >
                                                <List.Item.Meta
                                                    avatar={<FilePdfOutlined />}
                                                    title={t("account.adhesion") + " " + item.year + "/" + (+item.year + 1)}
                                                    description={t("account.fechaEnvio") + " " + moment(item.createdAt).format("DD/MM/yyyy")}
                                                />
                                            </List.Item>
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
        </>
    )
}

export default CentersView;
